import mod from "-!./Home.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Home.js?vue&type=script&lang=js&"